import React, { useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  ReferenceLine,
  Text,
} from 'recharts';

// Custom tooltip to display additional information
const CustomTooltip = ({ active, payload, label, setHoveredMonth }) => {
  if (active && payload && payload.length) {
    setHoveredMonth(label);

    return (
      <div className="bg-gray-800 text-white p-2 rounded-lg shadow-md">
        <p className="font-semibold">{label}</p>
        <p className="text-blue-400">Revenue : ${payload[0].value}</p>
        <p className="text-orange-400">Sales : {payload[1].value}</p>
      </div>
    );
  }
  return null;
};

const Linechart = ({ data }) => {
  const [hoveredMonth, setHoveredMonth] = useState(null); // State to track hovered month

  // Custom X-axis tick component
  const CustomXAxisTick = (props) => {
    const { x, y, payload } = props;
    const isHovered = hoveredMonth === payload.value.trim(); // Check if the current label is hovered
    const abbreviatedMonth = payload.value.trim().slice(0, 3); // Get first three letters

    return (
      <Text
        x={x}
        y={y + 10}
        fill={isHovered ? '#6366F1' : '#666'}
        fontWeight={isHovered ? 'bold' : 'normal'}
        textAnchor="middle"
      >
        {abbreviatedMonth}
      </Text>
    );
  };

  // Function to generate Y values for Revenue (left) and Sales (right) in intervals
  const getYIntervals = (min, max, steps) => {
    const interval = (max - min) / (steps - 1);
    const values = [];
    for (let i = 0; i < steps; i++) {
      values.push(min + i * interval);
    }
    return values;
  };

  // Find the min and max values for both revenue and sales
  const minRevenue = Math.min(...data.map(d => d.revenue));
  const maxRevenue = Math.max(...data.map(d => d.revenue));
  const minSales = Math.min(...data.map(d => d.sales));
  const maxSales = Math.max(...data.map(d => d.sales));

  // Define how many intervals you want for each axis
  const revenueIntervals = getYIntervals(minRevenue, maxRevenue, 5); // 5 intervals for revenue
  const salesIntervals = getYIntervals(minSales, maxSales, 5); // 5 intervals for sales

  return (
    <div className="col-span-3 p-4 bg-white rounded-lg shadow-md">
      <h3 className="text-lg font-semibold">Statistic</h3>
      <p className="text-gray-500">Revenue and Sales</p>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data} margin={{ right: 40, left: 0, bottom: 0 }}>
          <XAxis dataKey="month" tick={<CustomXAxisTick />} interval={0} />
          
          {/* First Y-Axis for Revenue */}
          <YAxis
            tickFormatter={(value) => `$${value}`}
            domain={['auto', 'auto']} // Let Recharts determine the Y-axis range
            yAxisId="left" // Specify this is the left Y-Axis
          />

          <Tooltip
            content={<CustomTooltip setHoveredMonth={setHoveredMonth} />}
          />
          
          <Legend
            verticalAlign="top"
            align="right"
            iconType="circle"
            wrapperStyle={{ paddingBottom: 20 }}
            formatter={(value) =>
              value === 'revenue' ? 'Revenue' : 'Sales'
            }
          />
          
          {/* Line for Revenue */}
          <Line 
            type="monotone" 
            dataKey="revenue" 
            stroke="#6366F1" 
            strokeWidth={2} 
            dot={false} 
            yAxisId="left" // Link this line to the left Y-Axis
          />
          
          {/* Line for Sales */}
          <Line 
            type="monotone" 
            dataKey="sales" 
            stroke="#FB923C" 
            strokeWidth={2} 
            dot={false} 
            yAxisId="left" // Link this line to the left Y-Axis (same as Revenue)
          />

          {/* Add horizontal ReferenceLine for Revenue intervals */}
          {revenueIntervals.map((tick, index) => (
            <ReferenceLine
              key={index}
              y={tick} // Place the reference line at the interval value for Revenue
              stroke="#e5e7eb"
              strokeDasharray="3 3" // Dotted line style
              yAxisId="left" // Link to the left Y-Axis for Revenue
            />
          ))}

          {/* Add horizontal ReferenceLine for Sales intervals */}
          {/* {salesIntervals.map((tick, index) => (
            <ReferenceLine
              key={index}
              y={tick} // Place the reference line at the interval value for Sales
              stroke="#e5e7eb"
              strokeDasharray="3 3" // Dotted line style
              yAxisId="left" // Link to the left Y-Axis for Sales
            />
          ))} */}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Linechart;


// import React, { useState, useEffect, useMemo } from 'react';
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   Legend,
//   ReferenceLine,
//   Text,
// } from 'recharts';

// // ... (Keep CustomTooltip component the same as before)

// const Linechart = ({ data }) => {
//   const [hoveredMonth, setHoveredMonth] = useState(null);
//   const [selectedYear, setSelectedYear] = useState('');

//   // Extract available years from data
//   const years = useMemo(() => {
//     const yearSet = new Set();
//     data.forEach(item => {
//       const year = item.month.split(' ')[1]; // Assuming "Month YYYY" format
//       yearSet.add(year);
//     });
//     return Array.from(yearSet).sort((a, b) => b - a); // Sort descending
//   }, [data]);

//   // Set initial year to most recent
//   useEffect(() => {
//     if (years.length > 0 && !selectedYear) {
//       setSelectedYear(years[0]);
//     }
//   }, [years, selectedYear]);

//   // Filter data based on selected year
//   const filteredData = useMemo(() => {
//     if (!selectedYear) return [];
//     return data.filter(item => {
//       const year = item.month.split(' ')[1];
//       return year === selectedYear;
//     });
//   }, [data, selectedYear]);


//   // Custom tooltip to display additional information
// const CustomTooltip = ({ active, payload, label, setHoveredMonth }) => {
//   if (active && payload && payload.length) {
//     setHoveredMonth(label);

//     return (
//       <div className="bg-gray-800 text-white p-2 rounded-lg shadow-md">
//         <p className="font-semibold">{label}</p>
//         <p className="text-blue-400">Revenue : ${payload[0].value}</p>
//         <p className="text-orange-400">Sales : {payload[1].value}</p>
//       </div>
//     );
//   }
//   return null;
// };

// // Custom X-axis tick component
// const CustomXAxisTick = (props) => {
//   const { x, y, payload } = props;
//   const isHovered = hoveredMonth === payload.value.trim(); // Check if the current label is hovered
//   const abbreviatedMonth = payload.value.trim().slice(0, 3); // Get first three letters

//   return (
//     <Text
//       x={x}
//       y={y + 10}
//       fill={isHovered ? '#6366F1' : '#666'}
//       fontWeight={isHovered ? 'bold' : 'normal'}
//       textAnchor="middle"
//     >
//       {abbreviatedMonth}
//     </Text>
//   );
// };

//   // Calculate Y-axis intervals
//   const getYIntervals = (min, max, steps) => {
//     if (min === max) return [min];
//     const interval = (max - min) / (steps - 1);
//     return Array.from({ length: steps }, (_, i) => min + i * interval);
//   };

//   const minRevenue = Math.min(...filteredData.map(d => d.revenue));
//   const maxRevenue = Math.max(...filteredData.map(d => d.revenue));
//   const minSales = Math.min(...filteredData.map(d => d.sales));
//   const maxSales = Math.max(...filteredData.map(d => d.sales));

//   const revenueIntervals = getYIntervals(minRevenue, maxRevenue, 5);
//   const salesIntervals = getYIntervals(minSales, maxSales, 5);

//   return (
//     <div className="col-span-3 p-4 bg-white rounded-lg shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         <div>
//           <h3 className="text-lg font-semibold">Statistic</h3>
//           <p className="text-gray-500">Revenue and Sales</p>
//         </div>
//         <select
//           value={selectedYear}
//           onChange={(e) => setSelectedYear(e.target.value)}
//           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5"
//         >
//           {years.map(year => (
//             <option key={year} value={year}>{year}</option>
//           ))}
//         </select>
//       </div>

//       <ResponsiveContainer width="100%" height={300}>
//         <LineChart data={filteredData} margin={{ right: 40, left: 0, bottom: 0 }}>
//           <XAxis dataKey="month" tick={<CustomXAxisTick />} interval={0} />
          
//           <YAxis
//             tickFormatter={(value) => `$${value}`}
//             domain={['auto', 'auto']}
//             yAxisId="left"
//           />

//           <Tooltip content={<CustomTooltip setHoveredMonth={setHoveredMonth} />} />
          
//           <Legend
//             verticalAlign="top"
//             align="right"
//             iconType="circle"
//             wrapperStyle={{ paddingBottom: 20 }}
//             formatter={(value) => value === 'revenue' ? 'Revenue' : 'Sales'}
//           />
          
//           <Line 
//             type="monotone" 
//             dataKey="revenue" 
//             stroke="#6366F1" 
//             strokeWidth={2} 
//             dot={false} 
//             yAxisId="left"
//           />
          
//           <Line 
//             type="monotone" 
//             dataKey="sales" 
//             stroke="#FB923C" 
//             strokeWidth={2} 
//             dot={false} 
//             yAxisId="left"
//           />

//           {revenueIntervals.map((tick, index) => (
//             <ReferenceLine
//               key={`rev-${index}`}
//               y={tick}
//               stroke="#e5e7eb"
//               strokeDasharray="3 3"
//               yAxisId="left"
//             />
//           ))}

//           {salesIntervals.map((tick, index) => (
//             <ReferenceLine
//               key={`sales-${index}`}
//               y={tick}
//               stroke="#e5e7eb"
//               strokeDasharray="3 3"
//               yAxisId="left"
//             />
//           ))}
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default Linechart;
